import { getAnalyticsTracker, setAnalyticsPage } from "analytics";
import { Collapsible } from "components/Collapsible";
import { DownloadButton } from "components/DownloadButton";
import { ExtraMaterial } from "components/ExtraMaterial";
import { ASSETS_TYPES } from "constants/index";
import { useBook } from "hooks/useBook";
import { Footer } from "layout/Footer";
import { HeaderMenu } from "layout/HeaderMenu";
import { observer } from "mobx-react";
import type { PathParams } from "models/path/Path";
import type React from "react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import {
  CollapsibleContainer,
  MaterialHeader,
  StyleTitle,
  TeacherOverviewContainer,
} from "./TeacherOverview.styled";

export const TeacherOverview: React.FC = observer(() => {
  const { t } = useTranslation("material");
  const { additionalsId }: PathParams = useParams();
  const { bookInfo, assetsInfo, fetchBook, fetchOneBookAssets } = useBook();

  useEffect(() => {
    if (getAnalyticsTracker()) {
      setAnalyticsPage(additionalsId, "overview", additionalsId);
    }
  }, [additionalsId]);

  useEffect(() => {
    fetchBook(additionalsId);
  }, [fetchBook, additionalsId]);

  useEffect(() => {
    fetchOneBookAssets(additionalsId);
  }, [fetchOneBookAssets, additionalsId]);
  const extraMaterial = assetsInfo?.filter((a) => a.type !== "flashcard");
  const extraMaterialTeachers = extraMaterial?.filter((a) => a.role === "teacher");
  const extraMaterialStudents = extraMaterial?.filter((a) => a.role === "student");

  return (
    <>
      <HeaderMenu isTeacher dataCy="header-teacher-menu" />
      <TeacherOverviewContainer>
        <StyleTitle data-cy="book-title">{bookInfo?.title}</StyleTitle>
        <CollapsibleContainer>
          <Collapsible
            headerComponent={
              extraMaterial.length > 0 && (
                <DownloadButton
                  documents={extraMaterial?.filter((a) => a.type === ASSETS_TYPES.document)}
                />
              )
            }
            title={t("additionals.extraMaterial")}
          >
            <MaterialHeader>
              {t("additionals.teachersMaterial", "Teachers material")}
            </MaterialHeader>
            <ExtraMaterial assets={extraMaterialTeachers} />
            <MaterialHeader>
              {t("additionals.studentsMaterial", "Students material")}
            </MaterialHeader>
            <ExtraMaterial assets={extraMaterialStudents} />
          </Collapsible>
        </CollapsibleContainer>
      </TeacherOverviewContainer>
      <Footer />
    </>
  );
});
